const carouselItems = [
  {
    title: '夏日影视盛宴',
    subtitle: '七月最值得看的热门内容',
    img: 'https://readdy.ai/api/search-image?query=Warm%20summery%20abstract%20composition%20with%20coral%20orange%20and%20deep%20teal%20gradient%20layers%2C%20flowing%20geometric%20shapes%20suggesting%20cinematic%20movement%2C%20soft%20glow%20effects%2C%20editorial%20magazine%20cover%20aesthetic%2C%20clean%20sophisticated%20design%2C%20no%20text&width=800&height=480&seq=carousel-01&orientation=landscape',
    tag: '热门专题',
  },
  {
    title: '纪录片发现之旅',
    subtitle: '高分神作一次看够',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20visual%20with%20warm%20amber%20and%20muted%20teal%20blocks%2C%20organic%20curved%20shapes%20with%20subtle%20transitions%2C%20sophisticated%20editorial%20design%20style%2C%20clean%20minimal%20composition%2C%20soft%20gradient%20background%2C%20no%20text&width=800&height=480&seq=carousel-02&orientation=landscape',
    tag: '精选合集',
  },
  {
    title: '动漫新番全追踪',
    subtitle: '七月新番完整追更指南',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20art%20with%20vibrant%20warm%20coral%20and%20teal%20energy%2C%20bold%20geometric%20shapes%20intersecting%2C%20modern%20editorial%20cover%20style%2C%20clean%20background%20with%20subtle%20texture%2C%20no%20text%20or%20letters&width=800&height=480&seq=carousel-03&orientation=landscape',
    tag: '追番必备',
  },
  {
    title: '综艺欢乐集结',
    subtitle: '热门综艺全程收录',
    img: 'https://readdy.ai/api/search-image?query=Playful%20abstract%20composition%20with%20warm%20coral%20orange%20and%20teal%20gradients%2C%20rounded%20geometric%20shapes%20floating%20organically%2C%20clean%20contemporary%20editorial%20design%2C%20soft%20lighting%20effects%2C%20no%20text&width=800&height=480&seq=carousel-04&orientation=landscape',
    tag: '娱乐频道',
  },
  {
    title: '体育精彩回顾',
    subtitle: '各大联赛精华集锦',
    img: 'https://readdy.ai/api/search-image?query=Bold%20abstract%20visual%20with%20warm%20coral%20and%20deep%20teal%20color%20blocks%2C%20geometric%20shapes%20with%20strong%20contrast%2C%20modern%20editorial%20sports%20aesthetic%2C%20clean%20minimalist%20design%2C%20no%20text%20or%20typography&width=800&height=480&seq=carousel-05&orientation=landscape',
    tag: '赛事集锦',
  },
  {
    title: '短剧每日更新',
    subtitle: '精彩短剧不断档',
    img: 'https://readdy.ai/api/search-image?query=Contemporary%20abstract%20art%20with%20warm%20coral%20and%20amber%20gradients%2C%20layered%20translucent%20shapes%20with%20soft%20shadows%2C%20editorial%20magazine%20spread%20design%2C%20clean%20sophisticated%20composition%2C%20no%20text&width=800&height=480&seq=carousel-06&orientation=landscape',
    tag: '热门连载',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            编辑精选 · 六大主题内容一网打尽
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-xl overflow-hidden cursor-default"
            >
              <div className="aspect-[5/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold text-white">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-white/70">
                  {item.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}